<template>
  <v-flex>
    <app-drawer
      v-if="storesLoaded"
      class="app--drawer"
    />

    <app-toolbar
      v-if="storesLoaded"
      class="app--toolbar"
    />

    <v-content>
      <!-- Page Header -->
      <page-header v-if="$route.meta.breadcrumb"/>
      <actions-toolbar/>
      <div class="page-wrapper">
        <loading-state
          v-if="fetchingStatus"
          :loading="fetchingStatus"
        />
        <template v-else>
          <v-dialog
            v-if="tos"
            v-model="tosDialog"
            persistent
            max-width="600px"
          >
            <terms-of-service
              :tos="tos"
              @accepted="accepted"/>
          </v-dialog>
          <router-view :key="$route.fullPath" />
        </template>
      </div>
    </v-content>
  </v-flex>
</template>

<script>
import AppDrawer from '@/components/AppDrawer'
import AppToolbar from '@/components/AppToolbar'
import ActionsToolbar from '@/components/ActionsToolbar'
import LoadingState from '@/components/LoadingState'
import PageHeader from '@/components/PageHeader'
import TermsOfService from '@/components/TermsOfService'
import { mapGetters } from 'vuex'

export default {
  name: 'BaseLayout',

  components: {
    TermsOfService,
    AppToolbar,
    PageHeader,
    ActionsToolbar,
    AppDrawer,
    LoadingState
  },

  data () {
    return {
      tos: null,
      tosDialog: false,
      tosAccepted: false
    }
  },

  computed: {
    ...mapGetters(['fetchingStatus', 'storesLoaded']),
    ...mapGetters({
      user: 'auth/me'
    })
  },

  async mounted () {
    this.tos = await this.$http.make('auth:tos').getAdminToS()

    if (!this.tos) {
      return
    }

    if (this.tos.version !== this.user.accepted_tos) {
      this.tosDialog = true
    }

    if (this.tos.version === this.user.accepted_tos) {
      this.tosDialog = false
      this.tosAccepted = true
    }
  },

  methods: {
    accepted () {
      this.tosDialog = false
      this.tosAccepted = true
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-wrapper
  margin-top: 40px;
  min-height: calc(100vh - 64px - 50px - 81px);
</style>
